// ============================================================================
// loading.js — ซ่อน/แสดงวงหมุนเต็มจอ (#loading ใน public/index.html)
//
// ★ วงหมุนอยู่ใน index.html ไม่ใช่ใน React — จึงขึ้นตั้งแต่ตอนที่ JS ยังโหลดไม่เสร็จ
//   (เน็ตมือถือช้า ๆ จะไม่เห็นจอขาวเปล่า) แล้วหน้าแรกที่ mount เสร็จค่อยสั่งซ่อน
// ★ แยกออกมาจาก CustomComponent.js ของหลังบ้าน — import ฟังก์ชันเล็ก ๆ ตัวนี้ตัวเดียว
//   ไม่ต้องลาก MUI / react-bootstrap / css ของ admin ติดเข้ามาใน bundle
// ============================================================================

export const loading = (status) => {
    const el = typeof document !== "undefined" ? document.getElementById("loading") : null;
    if (!el) return;
    el.hidden = status !== true;
};

export default loading;
